import React from 'react';
import type { Props as HeroProps } from 'Components/widgets/hero/Hero';
import { Hero } from 'Components/widgets/hero/Hero';
type Props = HeroProps & {
  id?: string;
  isExclusiveCollection: boolean;
};
export const HighlightLine = (props: Props) => (
  <Hero
    {...props}
    className="Line Line-Highlight"
    hLevel={2}
    size={props.size === 'small' ? 'highlightSmall' : 'highlight'}
    trackingData={{
      actionGA: 'highlight',
    }}
  />
);
